import { PhoneMaskProcessing } from './phone';

export class PhoneExtMaskProcessing extends PhoneMaskProcessing {
  protected fixedPosGroupingChars = ['(', , , , ')', ' ', , , , '-', , , , , ' ', 'x'];
  protected maxLength = 20;
}
